export const CompanySourceEnum = {
  GROUND_CONTROL: 'ground-control',
  HUBSPOT: 'hubspot',
};

export type CompanySourceType = (typeof CompanySourceEnum)[keyof typeof CompanySourceEnum];
